// src/redux/profileCountSlice.js

import { createSlice } from "@reduxjs/toolkit";

const messageCountSlice = createSlice({
  name: "messageCount",
  initialState: {
    limit: 0,
  },
  reducers: {
    setMessageCount: (state, action) => {
      state.limit = action.payload;
    },
  },
});

export const { setMessageCount} =
  messageCountSlice.actions;

export default messageCountSlice.reducer;
